import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayblastNextframeNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M23.4445 10.9875L10.2445 2.58745C9.4855 2.07165 8.3711 2.68095 8.4 3.59995V11.9995H23.9999C23.9997 11.5895 23.7912 11.2078 23.4445 10.9875Z"
        fill={color}
      />
      <path
        d="M23.4445 13.0114L10.2445 21.4114C9.4855 21.9272 8.3711 21.3179 8.4 20.3989V11.9994H23.9999C23.9997 12.4094 23.7912 12.7911 23.4445 13.0114Z"
        fill={color}
      />
      <path d="M6.37741 3.59998H0.377411V20.4H6.37741V3.59998Z" fill={color} />
      <path
        d="M0.377411 20.4C0.377411 21.0633 0.914111 21.6 1.57741 21.6H5.17741C5.84071 21.6 6.37741 21.0633 6.37741 20.4H0.377411Z"
        fill={color}
      />
      <path
        d="M5.17739 2.40002H1.57729C0.913989 2.40002 0.377289 2.93672 0.377289 3.60002H6.37729C6.37729 2.93672 5.84069 2.40002 5.17739 2.40002Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PlayblastNextframeNsk.displayName = 'PlayblastNextframeNsk';
